import React from "react";

function ViewChildCategory({ data }) {
  const categoryName =  data?.sub_category_details?.category_details?.name ||
    data?.sub_category_details?.category?.name ||
    "-";

  const subCategoryName =
    data?.sub_category_details?.name ||
    data?.sub_category?.name ||
    "-";

  return (
    <>

   <div className="main_page">
    <div className="row">


        <div className="col-md-6 mb-3">
            <label>Vendor</label>
            <input
              type="text"
              className="form-control"
              value={data?.vendor?.name || data?.user?.name || data?.user_id ||data?.mobile|| ""}
              disabled
            />
          </div>
        <div className="col-md-6 mb-3">
            <label>Category</label>
            <input
              type="text"
              className="form-control"
              value={categoryName}
              disabled
            />
          </div>
        <div className="col-md-6 mb-3">
            <label> Sub Category</label>
            <input
              type="text"
              className="form-control"
              value={subCategoryName}
              disabled
            />
          </div>
        {/* <div className="col-md-6 mb-3">
            <label> Child Category</label>
            <input
              type="text"
              className="form-control"
              value={data?.name }
              disabled
            />
          </div> */}
        <div className="col-md-6 mb-3">
            <label> Name</label>
            <input
              type="text"
              className="form-control"
              value={data?.name }
              disabled
            />
          </div>
      <div className="col-md-6 mb-3">
            <label>Status</label>
            <input
              type="text"
              className="form-control"
              value={data?.status === 1 || data?.status === true ? "Active" : "Inactive"}
              disabled
            />
          </div>

    </div>

   </div>



     
    </>
  );
}

export default ViewChildCategory;












